'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extractDurationHelper = require('./extractDurationHelper');

var _extractDurationHelper2 = _interopRequireDefault(_extractDurationHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contracts, type) {
    var contractsOfType = contracts.filter(function (c) {
        return c.contract_type === type;
    });
    var nonForwardStartingContracts = contractsOfType.filter(function (c) {
        return !c.forward_starting_options;
    });

    if (nonForwardStartingContracts.length === 0) {
        return undefined;
    }

    return (0, _extractDurationHelper2.default)(nonForwardStartingContracts, type);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/duration/extractDuration.js
// module id = 89
// module chunks = 0